import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { LoginState, LoginWithNewPasswordState, LoginWithOnetimeCode } from './types';

export const loginState = atomWithReset<LoginState>({
  organizationName: null,
  passwordPolicy: null,
});

export const loginWithNewPasswordState = atomWithReset<LoginWithNewPasswordState>({
  isRequired: false,
  username: null,
  practitionerCode: null,
});

export const loginWithOnetimeCodeState = atom<LoginWithOnetimeCode>({
  isRequired: false,
  username: null,
  password: null,
});
